
import React from 'react';

import FSIndex from "@dndComponents/FSIndex";

export default function PactBoonIndex() {
  return (
    <FSIndex
      data_type="pact_boon"
    />
  );
}
